import React from "react"
import styled from "styled-components"
import {Label} from "@irati/ui/src/Typography"
import {Hr} from "@irati/ui/src/Layout"

const Container = styled.div`
  text-align: center;
  width: 100%;
`

const Text = styled(Label)`
  background-color: ${({theme}) => theme.colors.greys.white};
  padding: 0 ${({theme}) => theme.spacing.one};
  color: ${({theme}) => theme.colors.fontColor};
  white-space: nowrap;
`

const LineThrough = styled(Hr)`
  margin-top: -12px;
`
interface LineThroughText {
  text?: string
  children?: JSX.Element
}
const LineThroughText: React.FC<LineThroughText> = ({text, children}) => {
  return (
    <Container>
      <Text>{text || children}</Text>
      <LineThrough />
    </Container>
  )
}

export default LineThroughText
